import useSearchNearProducts from './useSearchNearProducts'

export default useSearchNearProducts
